// ✅ ModifierMaterial.vue
<template>
  <div class="container mt-5">
    <div class="card p-4 shadow border-0" style="border-radius: 16px;">
      <h4 class="mb-4 text-dark">Edit Material</h4>

      <form @submit.prevent="handleUpdate">
        <div class="row">
          <div class="col-md-6 mb-4">
            <div class="p-3 bg-white shadow-sm rounded">
              <label for="name" class="form-label">Name</label>
              <input type="text" class="form-control" id="name" v-model="form.name" required />
            </div>
          </div>

          <div class="col-md-6 mb-4">
            <div class="p-3 bg-white shadow-sm rounded">
              <label for="reference" class="form-label">Reference</label>
              <input type="text" class="form-control" id="reference" v-model="form.reference" required />
            </div>
          </div>

          <div class="col-md-6 mb-4">
            <div class="p-3 bg-white shadow-sm rounded">
              <label for="serialNumber" class="form-label">Serial Number</label>
              <input type="text" class="form-control" id="serialNumber" v-model="form.serialNumber" required />
            </div>
          </div>

          <div class="col-md-6 mb-4">
            <div class="p-3 bg-white shadow-sm rounded">
              <label for="type" class="form-label">Type</label>
              <input type="text" class="form-control" id="type" v-model="form.type" required />
            </div>
          </div>
        </div>

        <div class="text-end">
          <button type="submit" class="btn text-white" style="background-color: #b03a45;">
            Save Changes
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModifierMaterial",
  data() {
    return {
      form: {
        name: "",
        reference: "",
        serialNumber: "",
        type: ""
      }
    };
  },
  created() {
   // eslint-disable-next-line no-unused-vars
const id = this.$route.params.id;

    // TODO: Fetch the material using ID
    this.form = {
      name: "Printer",
      reference: "CAN456",
      serialNumber: "SN002",
      type: "Office"
    };
  },
  methods: {
    handleUpdate() {
      alert("Material updated successfully!");
      this.$router.push("/materiall");
    }
  }
};
</script>